<template>
<div class="vm-form">

    <slot></slot>

</div>
</template>
<script>

export default {
name: 'vm-form',
props: {
    
},
data() {
    return {
        
    }
}
}
</script>
<style scoped>

.vm-form {
    width: 100%;
}

</style>
